export const isPermissionDeniedMessage = (message) => {
  if (!message || typeof message !== "string") {
    return false;
  }

  const normalized = message.toLowerCase();

  return (
    normalized.includes("permission") ||
    normalized.includes("not authorized") ||
    normalized.includes("unauthorized") ||
    normalized.includes("access denied") ||
    normalized.includes("do not have access")
  );
};

export const FEATURE_COMING_SOON_MESSAGE = "This Feature is coming soon";

export const MODULE_ACCESS_DENIED_MESSAGE =
  "You don't have permission to access this page.";

export const SESSION_EXPIRED_MESSAGE =
  "Your session has expired. Please log in again.";

export const NETWORK_ERROR_MESSAGE = "Network error. Please try again.";

export const REQUEST_TIMEOUT_MESSAGE = "Request timed out. Please try again.";

export const isFeatureComingSoonMessage = (message) => {
  if (!message || typeof message !== "string") {
    return false;
  }

  return message.trim().toLowerCase().includes("feature is coming soon");
};

export const shouldSuppressErrorToast = (content) =>
  isPermissionDeniedMessage(content) || isFeatureComingSoonMessage(content);

export const getApiResponseStatusCode = (response) => {
  if (response == null || typeof response !== "object") {
    return undefined;
  }

  if (response.statusCode != null) {
    return Number(response.statusCode);
  }

  if (response.data?.statusCode != null) {
    return Number(response.data.statusCode);
  }

  return undefined;
};

export const isSuccessfulApiResponse = (response) => {
  const statusCode = getApiResponseStatusCode(response);

  if (statusCode == null) {
    return true;
  }

  return statusCode === 200;
};

export const getApiResponseErrorMessage = (response) =>
  response?.message || response?.error || response?.data?.message || null;
